<template>
  <ModalDialog
    ref="dialog"
    title="Edit Contact Despatch"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-truck"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="contactForm" :labelColumnSize="3">

      <FormRow label="Default Despatch Method">
        <FormOption label="Delivery" name="defaultDespatchType" setting="delivery" v-model="contact.defaultDespatchType" inline="true" />
        <FormOption label="Pickup" name="defaultDespatchType" setting="pickup" v-model="contact.defaultDespatchType" inline="true" />
      </FormRow>

      <FormRow label="Default Delivery Item">
        <DeliveryStockSearchableSelect v-model="contact.defaultDeliveryStockId" />
      </FormRow>

      <FormHorizontalRule />
      <FormRow label="Pickup - Full Self Serve Enabled" helpTip="If enabled, the contact will get full self-service access for pickups on the kiosk. This includes the ability to load additional orders not in the original pickup">
        <FormCheckbox v-model="contact.isPickupFullSelfServeEnabled" field="isPickupFullSelfServeEnabled" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import DeliveryStockSearchableSelect from '@/modules/despatch/components/deliveryStockSearchableSelect'

export default {
  name: "ContactEditDespatchDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    DeliveryStockSearchableSelect
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      contact: {
        defaultDespatchType: 'delivery',
        defaultDeliveryStockId: null,
        isPickupFullSelfServeEnabled: false
      },
      contactForm: {},
      submitting: false
    }
  },
  mounted() {
    
  },
  computed: {
  },
  methods: {
    show(contact) {
      // Reset form
      this.contact = { }
      this.contactForm = {}
      this.submitting = false

      if(contact != null) {
        this.contact = _.cloneDeep(contact)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var contactData = _.cloneDeep(this.$data.contact)
      var updateData = _.pick(contactData, ['defaultDespatchType', 'defaultDeliveryStockId', 'isPickupFullSelfServeEnabled'])

      this.$apiService.contactService.updateContact(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.contactForm = this.processFormResponse(err)
        })
    }
  }
}
</script>